import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { Button } from '@st-operations/uikit/src/v2/index.js'
import SharethisLogo from '@st-operations/uikit/svgs/sharethis-datasphere-logo.svg'

import '../../css/pages/ErrorPage.styl'
import { logErrorAsync } from '../lib/utility'

const ErrorPage = ({ error, resetErrorBoundary }) => {
  useEffect(() => {
    logErrorAsync(error)
  }, [error])

  return (
    <div role="alert" className="error-page">
      <svg className="error-page__logo" aria-label="Sharethis logo" viewBox={SharethisLogo.viewBox}>
        <use xlinkHref={`#${SharethisLogo.id}`} />
      </svg>
      <h1 className="error-page__header">Something went wrong!</h1>
      <p className="error-page__text">{error.message}</p>
      <Button onClick={resetErrorBoundary}>Try again</Button>
    </div>
  )
}

ErrorPage.propTypes = {
  resetErrorBoundary: PropTypes.func.isRequired,
  error: PropTypes.shape().isRequired,
}

export default React.memo(ErrorPage)
